export default {
   addToCart: "افزودن به سبد خرید",
  stock: "موجودی",
  outOfStock: "ناموجود",
  toman: "تومان",
  noProducts:"محصولی یافت نشد",


  urls: {
    ProductCategory:"/product-category",

  }
};
